import React from 'react';
import styled, { keyframes } from 'styled-components';
import g90Logo from 'assets/g90-logo-colored.svg';
import breakpoint from 'styled-components-breakpoint';

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const HeaderWrapper = styled.div`
    text-align: center;
    margin-bottom: 60px;
    margin-top: 130px;

    ${breakpoint('sm', 'md')`
        margin-bottom: 30px;
        margin-top: 90px;
    `}

    ${breakpoint('xs', 'sm')`
        margin-bottom: 20px;
        margin-top: 80px;
    `}
`;

const WelcomeMessage = styled.span`
    text-transform: uppercase;
    font-size: 16px;
    font-weight: bold;
`;

const IconWrapper = styled.div`
    animation: 5s ${fadeIn} ease-out;
`;

const G90Header = () => (
    <HeaderWrapper>
        <span>
            <WelcomeMessage>WELCOME TO</WelcomeMessage>
            <IconWrapper>
                <img style={{ width: '110px', height: '65px' }} src={g90Logo}/>
            </IconWrapper>
        </span>
    </HeaderWrapper>
);

export default G90Header;



// WEBPACK FOOTER //
// ./src/components/molecules/home/G90Header.js